import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {TitleFaviconService} from './title-fav-icon.service';
import {ConfigProvider} from '@mydocma/common';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {TaskScopeEnum, TaskService} from '@mydocma/task';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { PlatformModeService } from 'projects/mydocma/mm/src/lib/mm-offline/services/platform-mode.service';
import { CustomMatIconService } from '@mydocma/component-library/src/lib/custom-mat-icon';
import { OfflineLocalModeMessageService } from 'projects/mydocma/mm/src/lib/mm-offline/services/offline-local-mode-message.service';
import { NativeService } from '@mydocma/core/src/lib/native';
import { Logger } from '@mydocma/common/src/lib/logger';
import { MmMobileKeyboardService } from '@docma-mm-core/mobile-keyboard/mm-mobile-keyboard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'mydocma-app-template';
  private deeplinkReceived = false;

  constructor(
    private titleFaviconService: TitleFaviconService,
    private readonly configService: ConfigProvider<IMmConfig>,
    private readonly taskService: TaskService,
    private ngZone: NgZone,
    private router: Router,
    private platformModeService: PlatformModeService,
    private customMatIconService: CustomMatIconService,
    private offlineLocalModeMessageService: OfflineLocalModeMessageService,
    private nativeService: NativeService,
    private Logger: Logger,
    private mobileKeyboardService: MmMobileKeyboardService
  ) {}

  ngOnInit() {
    this.mobileKeyboardService.init();

    this.titleFaviconService.setTitleAndFavicon(this.configService.getConfigData().appName);

    this.taskService.observeTasks([TaskScopeEnum.global]);

    if(!this.nativeService.isWeb) {
      this.customMatIconService.initializeIcons();

      const appName = this.configService.getConfigData().appName;
      this.nativeService.initializeApp(appName + '-go');

      App.addListener('backButton', ({ canGoBack }) => {
        //Disable back button for Android
      });
    }
  }

  ngOnDestroy(): void {}
}

